export default __webpack_public_path__ + "static/media/ImageIcon.c4ad3ccc.svg";